module.exports = __webpack_public_path__ + "img/booking-expired-selected.93a62a24.svg";